/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDOCUMENTTYPE } from './IAPDOCUMENTTYPE';
import {
    IAPDOCUMENTTYPEFromJSON,
    IAPDOCUMENTTYPEFromJSONTyped,
    IAPDOCUMENTTYPEToJSON,
} from './IAPDOCUMENTTYPE';
import type { SignatoryProgressViewModel } from './SignatoryProgressViewModel';
import {
    SignatoryProgressViewModelFromJSON,
    SignatoryProgressViewModelFromJSONTyped,
    SignatoryProgressViewModelToJSON,
} from './SignatoryProgressViewModel';

/**
 * 
 * @export
 * @interface DocumentProgressViewModel
 */
export interface DocumentProgressViewModel {
    /**
     * 
     * @type {string}
     * @memberof DocumentProgressViewModel
     */
    contentManagerId: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentProgressViewModel
     */
    documentId: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentProgressViewModel
     */
    documentName: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentProgressViewModel
     */
    isGenerated?: boolean;
    /**
     * 
     * @type {IAPDOCUMENTTYPE}
     * @memberof DocumentProgressViewModel
     */
    documentType: IAPDOCUMENTTYPE;
    /**
     * 
     * @type {Array<SignatoryProgressViewModel>}
     * @memberof DocumentProgressViewModel
     */
    signatoriesProgress: Array<SignatoryProgressViewModel>;
}

/**
 * Check if a given object implements the DocumentProgressViewModel interface.
 */
export function instanceOfDocumentProgressViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contentManagerId" in value;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "documentType" in value;
    isInstance = isInstance && "signatoriesProgress" in value;

    return isInstance;
}

export function DocumentProgressViewModelFromJSON(json: any): DocumentProgressViewModel {
    return DocumentProgressViewModelFromJSONTyped(json, false);
}

export function DocumentProgressViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentProgressViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentManagerId': json['ContentManagerId'],
        'documentId': json['DocumentId'],
        'documentName': json['DocumentName'],
        'isGenerated': !exists(json, 'IsGenerated') ? undefined : json['IsGenerated'],
        'documentType': IAPDOCUMENTTYPEFromJSON(json['DocumentType']),
        'signatoriesProgress': ((json['SignatoriesProgress'] as Array<any>).map(SignatoryProgressViewModelFromJSON)),
    };
}

export function DocumentProgressViewModelToJSON(value?: DocumentProgressViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ContentManagerId': value.contentManagerId,
        'DocumentId': value.documentId,
        'DocumentName': value.documentName,
        'IsGenerated': value.isGenerated,
        'DocumentType': IAPDOCUMENTTYPEToJSON(value.documentType),
        'SignatoriesProgress': ((value.signatoriesProgress as Array<any>).map(SignatoryProgressViewModelToJSON)),
    };
}

